import React from 'react';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import { useSearchParams } from 'react-router-dom';
import { map, pick, join, reduce, split, find } from 'lodash';
import { useTranslation } from 'react-i18next';

import { Lists } from 'common-components/form-inputs/list-autocomplete';
import useListMapper from 'common-components/useListMapper';

const FilterMapping = {
  typeIds: {
    tKey: 'types',
    listKey: Lists.InstrumentTypes,
  },
  committeeIds: {
    tKey: 'committees',
    listKey: Lists.Committees,
  },
  statusIds: {
    tKey: 'status',
    listKey: Lists.InstrumentStatusTypes,
  },
  themeIds: {
    tKey: 'themes',
    listKey: Lists.Themes,
  },
  yearFrom: {
    tKey: 'from'
  },
  yearTo: {
    tKey: 'to'
  },
  dateType: {
    tKey: 'Date',
    listKey: Lists.AdvancedSearchDateType,
  },
  adherentIds: {
    tKey: 'Adherents',
    listKey: Lists.Countries,
  },
  countryIds: {
    tKey: 'Adherents',
    listKey: Lists.Countries,
  },
  term: {
    tKey: 'Fulltext search'
  },
  reference: {
    tKey: 'reference'
  },
};

const FilterItem = ({ name, value }) => {
  const { t } = useTranslation();
  const { getListItems } = useListMapper();
  const filterMeta = FilterMapping[name];
  if (!filterMeta) return null;

  let displayValue = '';
  if (filterMeta.listKey) {
    const listItems = getListItems(filterMeta.listKey);
    const filterValues = reduce(split(value, ','), (acc, itm) => {
      const valueListItem = find(listItems, x => String(x.id) === itm);
      if (valueListItem) {
        acc.push(valueListItem.nameKey ? t(valueListItem.nameKey) : valueListItem.name);
      }
      return acc;
    }, []);
    displayValue = join(filterValues, ', ');
  } else {
    displayValue = value;
  }
  return (
    <>
      {t(filterMeta.tKey)}: {displayValue}
    </>
  );
};

const ActivatedFilters = ({ hidden }) => {
  const [searchParams,] = useSearchParams();
  const searchParamsToDisplay = pick(Object.fromEntries(searchParams), Object.keys(FilterMapping));

  if (hidden) {
    return null;
  }

  return (
    <Box className={'showInPrint'}>
      <Grid container>
        {map(searchParamsToDisplay, (sp, spKey) => {
          return (
            <Grid item xs={12} key={spKey}>
              <FilterItem name={spKey} value={sp}/>
            </Grid>
          );
        })}
      </Grid>
    </Box>
  );
};

export default ActivatedFilters;
